import { BaseModel } from './base-model';
import { ZoneFeature } from './zones-base-interfaces';

export abstract class EcaSecaModelBase extends BaseModel
{
    abstract getEcaSecaZones(): Promise<ZoneFeature[] | null>;
}

let EcaSecaModel: EcaSecaModelBase|null = null;

function setEcaSecaModel(model: EcaSecaModelBase)
{
    EcaSecaModel = model;
}

export { EcaSecaModel, setEcaSecaModel };
